import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {DrawerService, IDrawerRef} from '../../../services/drawer.service';
import {
  CreativeGalleryDrawerComponent
} from '../../../components/messaging-screen/creative-gallery-drawer/creative-gallery-drawer.component';
import { GroupingTypeKey, MarketingResearchGroupingCreative, THEMES } from '../../../components/messaging-screen/types';

@Component({
  selector: 'app-creatives-renderer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './creatives-renderer.component.html',
  styleUrl: './creatives-renderer.component.scss'
})
export class CreativesRendererComponent implements ICellRendererAngularComp {
  public creatives: string[] = [];
  public creativeCount: number = 0;

  private readonly drawer: DrawerService = inject(DrawerService);
  private brandKey!: string;
  private theme!: string;
  private groupingType: GroupingTypeKey = THEMES;
  private creativeObjects: MarketingResearchGroupingCreative[] = [];
  private drawerRef?: IDrawerRef<CreativeGalleryDrawerComponent>;

  agInit(params: ICellRendererParams): void {
    this.loadComponent(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.loadComponent(params);
    return true;
  }

  private loadComponent(params: ICellRendererParams) {
    const value = params.value as any;
    this.creatives = value?.creatives || [];
    this.creativeCount = value?.creativeCount || 0;
    this.brandKey = value?.brandKey || '';
    this.theme = value?.theme || '';
    this.groupingType = value?.groupingType || THEMES;
    this.creativeObjects = value?.creativeObjects || [];
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img) {
      img.src = 'images/no-logo.png';
    }
  }

  openDrawer(): void {
    this.drawerRef =  this.drawer.open<CreativeGalleryDrawerComponent>(CreativeGalleryDrawerComponent, {
      data: {
        brandKey: this.brandKey,
        theme: this.theme,
        groupingType: this.groupingType,
        bucketCreatives: this.creativeObjects,
        close: this.closeDrawer.bind(this)
      },
    })
  }

  closeDrawer(): void {
    this.drawerRef?.close();
  }
}

